import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PurchaseOrderDetailResponse, PurchaseOrderResponse } from 'src/app/models/purchase-order.model';
import { ProductService } from 'src/app/services/product.service';
import { PurchaseOrderReceivedService } from 'src/app/services/purchase-order-received.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';

@Component({
  selector: 'app-modal-purchase-order-detail',
  templateUrl: './modal-purchase-order-detail.component.html',
  styleUrls: ['./modal-purchase-order-detail.component.scss']
})
export class ModalPurchaseOrderDetailComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  @Output() updateCurrency = new EventEmitter<number>();
  @Input() orderId: number;
  @Input() order: PurchaseOrderResponse;
  
  orderDetails: PurchaseOrderDetailResponse[] = [];
  editingItem: number | null = null;
  loading: { [key: number]: boolean } = {};
  loadingDeliveryDate: boolean = false;
  editDeliveryDate: boolean = false;
  isChanged: boolean = false;
  tempItem: any = null;
  currencyType = 0;
  loadingCurrency = false;
  receivedOrder: any = null;
  loadingReceived = false;

  constructor(
    private purchaseOrderService :PurchaseOrderService,
    private productService: ProductService,
    private toastService: ToastrService,
    private purchaseOrderReceivedService: PurchaseOrderReceivedService,
  ) { }

  ngOnInit(): void {
    this.getOrderDetail();
    this.getReceivedOrder();
  }

  getOrderDetail() {
    if (!this.orderId) {
      return;
    }
    this.currencyType = this.order.currency;
    this.purchaseOrderService.getOrder(this.orderId).subscribe({
      next: (response: any) => {
        this.orderDetails = response.data;
      },
      error: (error) => {
        this.toastService.error("Error al obtener los detalles del pedido", "Error");
      }
    });
  }

  formatDate(date: any): Date {
    return new Date(date);
  }

  startEditing(item: PurchaseOrderDetailResponse) {
    
    this.editingItem = item.id;
    this.tempItem = { ...item };
  }
  
  endEditing(item: PurchaseOrderDetailResponse) {
    if (this.tempItem) {
    // Restaurar los valores originales
    item.quantity = this.tempItem.quantity;
    item.cost = this.tempItem.cost;
  }
    this.editingItem = null;
    this.tempItem = null;
  }

  saveItem(item: any) {
    this.loading[item.id] = true;

    let data = {
      cost: item.cost,
      quantity: item.quantity
    }

    this.purchaseOrderService.putOrderDetailCostQuantity(this.orderId, item.productData.id, data)
    .subscribe({
      next: (response: any) => {
        this.getOrderDetail();
        this.editingItem = null;
        this.tempItem = null;
        this.loading[item.id] = false
        this.toastService.success("Datos Actualizados correctamente", "Exito");
      },
      error: (error) => {
        this.toastService.error("Error al actualizar el datalle", "Error");
        this.loading[item.id] = false
      }
    });
    
  }

  saveDeliveryDate() {
    if (!this.order) {
      return;
    }
    
    this.loadingDeliveryDate = true;
    this.purchaseOrderService.putOrderDeliverDate(this.order.id, new Date(this.order.deliveryDate)).subscribe({
      next: (response: any) => {
        this.toastService.success("Fecha de Entrega actualizada correctamente", "Éxito");
        this.loadingDeliveryDate = false;
        this.editDeliveryDate = false;
        this.isChanged = true;
      },
      error: (error) => {
        this.toastService.error("Error al actualizar la Fecha de Entrega", "Error");
        this.loadingDeliveryDate = false;
        this.editDeliveryDate = false;
      }
    });
  }

  setCurrency(){
    
  }

  updateExchange(){
    let newCurrency = 0;
    if (this.currencyType == 0) {
      newCurrency = 1;
    } else {
      newCurrency = 0;
    }
    this.loadingCurrency = true;
    this.purchaseOrderService.updateCurrency(this.orderId, newCurrency).subscribe({
      next: (response: any) => {
        this.order = response.data;
        this.toastService.success("Moneda actualizada", "Exito");
        this.getOrderDetail();
        this.order.currency = newCurrency;
        this.loadingCurrency = false;
        this.updateCurrency.emit(newCurrency);
      },
      error: (error) => {
        this.toastService.error("Error al actualizar moneda", "Error");
        this.loadingCurrency = false;
      }
    });
  }

  get totalCost(): number {
    if (this.orderDetails==null || this.orderDetails.length==0) {
      return 0;
    }
    return this.orderDetails.reduce((total, item) => total + (item.cost * item.quantity), 0);
  }

  get totalItems(): number {
    return this.orderDetails.reduce((total, item) => total + item.quantity, 0);
  }

  // Escucha global de la tecla Escape
  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close.emit(this.isChanged);
  }

  getReceivedOrder() {
    if (!this.orderId) return;

    this.loadingReceived = true;
    this.receivedOrder = null;

    this.purchaseOrderReceivedService.getReceivedOrderDetails(this.orderId).subscribe({
      next: (resp: any) => {
        this.receivedOrder = resp?.data ?? null;
        this.loadingReceived = false;
      },
      error: () => {
        this.receivedOrder = null;
        this.loadingReceived = false;
      }
    });
  }

}
